var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addValue"},[_c('searchForm',{attrs:{"formOptions":_vm.formOptions,"btnItems":_vm.btnItems},on:{"onSearch":_vm.onSearch}}),_c('page-table',{attrs:{"tableData":_vm.tableData,"tableLabel":_vm.tableLabel,"pager":_vm.pager},on:{"pagination":_vm.handleCurrentChange,"handleSizeChange":_vm.handleSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }